import Vue from 'vue'

const InterviewCheckInstance = Vue.extend(require('./index.vue').default);
let instance = null
let interviewCheckPromise = null
let interviewCheckResolve = null

let getInstance = () => {
  return new InterviewCheckInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (interviewCheckResolve) {
    interviewCheckResolve(false)
    interviewCheckResolve = null
  }
  interviewCheckPromise = null
}

let InterviewCheck = (msg) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  interviewCheckPromise = new Promise((resolve, reject) => {
    interviewCheckResolve = resolve
  })
  instance.open(msg, interviewCheckResolve)

  return interviewCheckPromise
}

export default InterviewCheck
